import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SlideToggleComponent } from './slide-toggle.component';
import { MatSlideToggle, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MatSlideToggleModule],
  declarations: [SlideToggleComponent],
  exports: [SlideToggleComponent],
  providers: [],
})
export class SlideToggleModule {}
